(function () {
  'use strict';

  const ZOOM_STEP = 0.5;
  const MIN_ZOOM = 1;
  const MAX_ZOOM = 4;

  let overlay = null;
  let currentIndex = 0;
  let images = [];
  let currentZoom = 1;
  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let translateX = 0;
  let translateY = 0;
  let lastTranslateX = 0;
  let lastTranslateY = 0;
  let initialPinchDistance = 0;
  let initialPinchZoom = 1;

  function getProductImages() {
    const mediaItems = document.querySelectorAll(
      '.product__media-list .product__media-item .product__modal-opener--image img'
    );
    const srcs = [];
    mediaItems.forEach(function (img) {
      // Get the highest resolution src
      let src = img.getAttribute('src');
      if (src) {
        // Remove width parameter to get full size, then request a large version
        src = src.replace(/&width=\d+/, '').replace(/\?width=\d+/, '');
        // Request a high-res version
        if (src.includes('?')) {
          src += '&width=2048';
        } else {
          src += '?width=2048';
        }
      }
      const alt = img.getAttribute('alt') || '';
      srcs.push({ src: src, alt: alt });
    });
    return srcs;
  }

  function createOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'fz-overlay';
    overlay.innerHTML =
      '<div class="fz-close" aria-label="Close">&times;</div>' +
      '<div class="fz-controls">' +
        '<button class="fz-btn fz-zoom-out" aria-label="Zoom out">&minus;</button>' +
        '<span class="fz-zoom-level">100%</span>' +
        '<button class="fz-btn fz-zoom-in" aria-label="Zoom in">&plus;</button>' +
      '</div>' +
      '<button class="fz-nav fz-prev" aria-label="Previous image">&#8249;</button>' +
      '<button class="fz-nav fz-next" aria-label="Next image">&#8250;</button>' +
      '<div class="fz-image-wrap">' +
        '<img class="fz-image" draggable="false" />' +
      '</div>';

    document.body.appendChild(overlay);

    // Close
    overlay.querySelector('.fz-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('fz-image-wrap')) {
        if (currentZoom <= 1) close();
      }
    });

    // Zoom controls
    overlay.querySelector('.fz-zoom-in').addEventListener('click', function (e) {
      e.stopPropagation();
      zoomTo(currentZoom + ZOOM_STEP);
    });
    overlay.querySelector('.fz-zoom-out').addEventListener('click', function (e) {
      e.stopPropagation();
      zoomTo(currentZoom - ZOOM_STEP);
    });

    // Navigation
    overlay.querySelector('.fz-prev').addEventListener('click', function (e) {
      e.stopPropagation();
      navigate(-1);
    });
    overlay.querySelector('.fz-next').addEventListener('click', function (e) {
      e.stopPropagation();
      navigate(1);
    });

    // Scroll wheel zoom
    overlay.querySelector('.fz-image-wrap').addEventListener('wheel', function (e) {
      e.preventDefault();
      if (e.deltaY < 0) {
        zoomTo(currentZoom + ZOOM_STEP * 0.5);
      } else {
        zoomTo(currentZoom - ZOOM_STEP * 0.5);
      }
    }, { passive: false });

    // Keyboard
    document.addEventListener('keydown', handleKeydown);

    // Drag to pan when zoomed
    var imgWrap = overlay.querySelector('.fz-image-wrap');
    imgWrap.addEventListener('mousedown', onDragStart);
    imgWrap.addEventListener('mousemove', onDragMove);
    imgWrap.addEventListener('mouseup', onDragEnd);
    imgWrap.addEventListener('mouseleave', onDragEnd);

    // Touch events for pinch zoom and pan
    imgWrap.addEventListener('touchstart', onTouchStart, { passive: false });
    imgWrap.addEventListener('touchmove', onTouchMove, { passive: false });
    imgWrap.addEventListener('touchend', onTouchEnd);

    // Double click to toggle zoom
    imgWrap.addEventListener('dblclick', function (e) {
      e.preventDefault();
      if (currentZoom > 1) {
        zoomTo(1);
      } else {
        zoomTo(2.5);
      }
    });
  }

  function onDragStart(e) {
    if (currentZoom <= 1) return;
    isDragging = true;
    startX = e.clientX - lastTranslateX;
    startY = e.clientY - lastTranslateY;
    overlay.querySelector('.fz-image').style.cursor = 'grabbing';
  }

  function onDragMove(e) {
    if (!isDragging) return;
    e.preventDefault();
    translateX = e.clientX - startX;
    translateY = e.clientY - startY;
    lastTranslateX = translateX;
    lastTranslateY = translateY;
    applyTransform();
  }

  function onDragEnd() {
    isDragging = false;
    if (overlay) {
      overlay.querySelector('.fz-image').style.cursor = currentZoom > 1 ? 'grab' : 'zoom-in';
    }
  }

  function onTouchStart(e) {
    if (e.touches.length === 2) {
      e.preventDefault();
      initialPinchDistance = getPinchDistance(e.touches);
      initialPinchZoom = currentZoom;
    } else if (e.touches.length === 1 && currentZoom > 1) {
      isDragging = true;
      startX = e.touches[0].clientX - lastTranslateX;
      startY = e.touches[0].clientY - lastTranslateY;
    }
  }

  function onTouchMove(e) {
    if (e.touches.length === 2) {
      e.preventDefault();
      var dist = getPinchDistance(e.touches);
      var scale = dist / initialPinchDistance;
      zoomTo(initialPinchZoom * scale);
    } else if (e.touches.length === 1 && isDragging) {
      e.preventDefault();
      translateX = e.touches[0].clientX - startX;
      translateY = e.touches[0].clientY - startY;
      lastTranslateX = translateX;
      lastTranslateY = translateY;
      applyTransform();
    }
  }

  function onTouchEnd() {
    isDragging = false;
    initialPinchDistance = 0;
  }

  function getPinchDistance(touches) {
    return Math.hypot(
      touches[0].clientX - touches[1].clientX,
      touches[0].clientY - touches[1].clientY
    );
  }

  function applyTransform() {
    var img = overlay.querySelector('.fz-image');
    img.style.transform = 'scale(' + currentZoom + ') translate(' + (translateX / currentZoom) + 'px, ' + (translateY / currentZoom) + 'px)';
  }

  function zoomTo(level) {
    currentZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, level));
    var img = overlay.querySelector('.fz-image');

    if (currentZoom <= 1) {
      translateX = 0;
      translateY = 0;
      lastTranslateX = 0;
      lastTranslateY = 0;
    }

    applyTransform();
    img.style.cursor = currentZoom > 1 ? 'grab' : 'zoom-in';
    overlay.querySelector('.fz-zoom-level').textContent = Math.round(currentZoom * 100) + '%';
  }

  function resetZoom() {
    currentZoom = 1;
    translateX = 0;
    translateY = 0;
    lastTranslateX = 0;
    lastTranslateY = 0;
  }

  function navigate(dir) {
    currentIndex = (currentIndex + dir + images.length) % images.length;
    resetZoom();
    showImage();
  }

  function showImage() {
    var img = overlay.querySelector('.fz-image');
    img.style.transform = 'scale(1)';
    img.style.cursor = 'zoom-in';
    img.src = images[currentIndex].src;
    img.alt = images[currentIndex].alt;
    overlay.querySelector('.fz-zoom-level').textContent = '100%';

    // Show/hide nav buttons
    var hasMultiple = images.length > 1;
    overlay.querySelector('.fz-prev').style.display = hasMultiple ? '' : 'none';
    overlay.querySelector('.fz-next').style.display = hasMultiple ? '' : 'none';
  }

  function open(index) {
    images = getProductImages();
    if (images.length === 0) return;

    currentIndex = index || 0;
    resetZoom();

    if (!overlay) createOverlay();

    showImage();
    overlay.classList.add('fz-active');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('fz-active');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleKeydown);
  }

  function handleKeydown(e) {
    if (!overlay || !overlay.classList.contains('fz-active')) return;
    switch (e.key) {
      case 'Escape':
        close();
        break;
      case 'ArrowLeft':
        navigate(-1);
        break;
      case 'ArrowRight':
        navigate(1);
        break;
      case '+':
      case '=':
        zoomTo(currentZoom + ZOOM_STEP);
        break;
      case '-':
        zoomTo(currentZoom - ZOOM_STEP);
        break;
    }
  }

  function init() {
    // Attach click handlers to all product media images
    var mediaItems = document.querySelectorAll('.product__media-list .product__media-item');
    mediaItems.forEach(function (item, idx) {
      var opener = item.querySelector('.product__modal-opener--image');
      if (!opener) return;

      // Make the whole area clickable with pointer cursor
      opener.style.cursor = 'zoom-in';

      opener.addEventListener('click', function (e) {
        // Don't interfere with video/3d model clicks
        if (e.target.closest('deferred-media, product-model')) return;
        e.preventDefault();
        e.stopPropagation();

        // Figure out which image index this is
        var allOpeners = document.querySelectorAll(
          '.product__media-list .product__media-item .product__modal-opener--image'
        );
        var clickedIndex = 0;
        allOpeners.forEach(function (op, i) {
          if (op === opener) clickedIndex = i;
        });

        open(clickedIndex);
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
